import * as React from 'react';
import { st, classes } from './Text.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { TextPriority, TextTypography, TextProps } from './types';

const Text: React.FunctionComponent<TextProps> = (props) => {
  const {
    typography = TextTypography.runningText,
    priority = TextPriority.primary,
    tagName,
    children,
    className,
    role,
    id,
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden,
    ...rest
  } = props;

  const isAriaHidden = !!ariaHidden && ariaHidden !== 'false';

  return (
    <TPAComponentsConsumer>
      {({ mobile }) => (
        <>
          {React.createElement(
            tagName || 'span',
            {
              className: st(
                classes.root,
                {
                  typography,
                  priority,
                  mobile,
                },
                className,
              ),
              'aria-hidden': isAriaHidden || !!ariaLabel,
              'aria-label': ariaLabel,
              'data-hook': props['data-hook'],
              'data-mobile': mobile || null,
              role,
              id,
              ...rest,
            },
            children,
          )}
          {!isAriaHidden && !!ariaLabel ? (
            <span
              className={classes['sr-only']}
              data-sr-only="true"
              data-hook={`${props['data-hook'] || 'wut-text'}-aria-label`}
            >
              {ariaLabel}
            </span>
          ) : null}
        </>
      )}
    </TPAComponentsConsumer>
  );
};

Text.displayName = 'Text';

export { Text };
